import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SliderOptions } from '../../../models/sections-model';
import { trigger, transition, group, query, style, animate, keyframes } from '@angular/animations';
import { wrapGrid } from 'animate-css-grid';

@Component({
  selector: 'kw-eye-slider',
  templateUrl: './eye-slider.component.html',
  styleUrls: ['./eye-slider.component.scss'],
  animations:[
    trigger('sliderAnimation',[
      transition(":increment",group([
        query(':enter',[
          style({opacity:0}),
          animate(1000, style({ opacity: 1 }))          
        ]),
        query(':leave', [
          style({ opacity: 1 }),
          animate(1000, style({ opacity: 0 }))
        ])
      ])),
      transition(":decrement", group([
        query(':enter', [
          style({ transform: 'translateX(-100%)',height:'330px' }),
          animate('0.5s linear', keyframes([
            style({ transform: 'translateX(-100%)',height:'330px' }),
            style({ transform: 'translateX(0)',height:'330px'})
          ]))
        ]),
        query(':leave', [
          animate('0.5s linear', style({ transform: 'translateX(100%)',height:'330px' }))
        ])
      ])),
    ])
  ]
})
export class EyeSliderComponent implements OnInit {
  @Input() data:SliderOptions;
  @Input() edit:boolean;
  
  slides:any[];
  itemsLength:number;
  actualIndex = 0;
  selectedIndex = 0;
  autoStart = true;

  slideGroups:any[]=[];

  @ViewChild('gridContainer', {read: ElementRef}) gridContainer:ElementRef<HTMLElement>
  constructor() { }

  ngOnInit(): void {
    console.log(this.data)
    this.slides = this.data.slides;
    this.slideGroups.push(this.slides);
    for(let i=0;i<this.slides.length-1;i++){
      this.move(this.slideGroups[i],0,this.slides.length-1);
    }
    this.itemsLength = this.slides.length;
  }

  ngAfterViewInit(): void {
    wrapGrid(this.gridContainer.nativeElement,{
      duration: 300,
      stagger: 10,
    })
  }

  move(arr:any,from:number,to:number){
    console.log(from,to);
    //console.log(this.slides);
    let newArr = [...arr]
    newArr.splice(to,0,newArr.splice(from,1)[0]);
    this.slideGroups.push(newArr);
    console.log(this.slideGroups);
  }

  get items() {
    console.log(this.actualIndex);
    return [this.slideGroups[this.actualIndex]];
  }

}
/* const newArr = [...arr];

    const item = newArr.splice(from, 1)[0];
    newArr.splice(to, 0, item);

    return newArr; */